import React, { FC } from 'react';
import styles from './ToggleButton.module.css';

export interface ToggleButtonProps {
    id?: string;
    name: string;
    value: string;
    label: string;
    checked?: boolean;
    onChange?: (value: string) => void;
    classes?: string;
}

export const ToggleButton: FC<ToggleButtonProps> = ({ id, name, value, label, checked, onChange, classes }) => {
    return (
        <label className={`${styles.toggleButton} ${classes || ''} ${checked ? styles.checked : ''}`}>
            <input
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={checked}
                onChange={() => onChange && onChange(value)}
                className={styles.toggleInput}
            />
            <span className={styles.toggleLabel}>{label}</span>
        </label>
    );
};
